import { FormBuilderSchema } from "../../../modules/FormBuilderCore/Types"

export type TandemAccount = {
	id: number
	name: string
	description: string
	acceptedPayees: string[]
}

export type TandemFieldConfiguration = {
	fieldName: string
	displayName: string
	description: string
	properties: TandemFieldProperties | undefined
	formBuilderSchema: FormBuilderSchema
}

export type TandemFieldInstance = {
	id: number
	accountId: number
	fieldName: string
	properties: TandemFieldProperties
}

export type TandemFieldProperties = {
	threshold: number
} & Record<string, unknown>

export type BaseTandemAccountModel = {
	name: string
	description: string
	acceptedPayees: string[]
}

export type BaseTandemFieldInstanceModel = {
	fieldName: string
	properties: TandemFieldProperties
}

export type TandemLicenseInfo = Version00TandemLicenseInfo | Version01TandemLicenseInfo

export type Version00TandemLicenseInfo = {
	type: 'Version00'
	startDate: Date
	expirationDate?: Date
	quotaType: QuotaType
	quotaInfo: QuotaInfo
}

export type Version01TandemLicenseInfo = {
	type: 'Version01'
	fieldQuotaInfo: Record<string, QuotaInfo>
	startDate: Date
	expirationDate?: Date
} 

export enum QuotaType {
	Pages = 0,
	Fields = 1
}

export enum CountingType {
	AllTime = 0,
	Annual = 1
}

type QuotaInfo = {
	exceeded: boolean
	quota: number
	used: number
	countingType: CountingType
}